import * as React from "react";
import type { HeadFC, PageProps } from "gatsby";
import { graphql } from "gatsby";
import { Responsive, WidthProvider } from "react-grid-layout";

import "@/styles/css/react-grid-layout.css";
import "@/styles/css/react-resizable.css";
import styled from "styled-components";
import HorizonalCard from "@/components/Card/horizonalCard";
import { ArrowUpRight } from "react-feather";
// import SpotifyCard from "@/components/Card/spotifyCard";
import VarticalCard from "@/components/Card/verticalCard";
import SquareCard from "@/components/Card/squareCard";
import PaddingVertical from "@/components/Layout/PaddingVertical";
// import SpotifyNowPlaying from "@/spotify/SpotifyNowPlaying";
import { SEO } from "@/components/seo";
import posterIndex from "../images/metaimages/index.jpg";

const StyledTitle = styled.h1`
  font-family: var(--font-serif-ogg);
  font-weight: 600;
  letter-spacing: 0.03em;
  margin-bottom: 0.4em;
`;

const StyledHighlighter = styled.span`
  background-color: ${({ theme }) => theme.colors.accent};
  padding: 0 4px;
  font-weight: 500;
`;

const StyledGridWrapper = styled.div`
  margin: 0 auto;
  margin-bottom: 1em;
  width: 100%;
  max-width: 1200px;

  @media (min-width: 400px) {
    width: 338px;
  }

  @media (min-width: 800px) {
    width: 720px;
  }

  @media (min-width: 880px) {
    width: 770px;
  }

  @media (min-width: 1200px) {
    min-width: 1030px;
  }
`;

// const StyledLoaderWrapper = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   height: 80vh;
// `;

const IndexPage: React.FC<PageProps> = ({ data }: any) => {
  // const { result, loading } = SpotifyNowPlaying();

  const ResponsiveGridLayout = WidthProvider(Responsive);
  const getImageObj = (name: string) => {
    const obj = data?.allFile?.nodes?.filter(
      (node: any) => node?.name === name
    );
    return obj[0]?.childImageSharp?.gatsbyImageData;
  };

  const layout = [
    { i: "a", x: 0, y: 0, w: 6, h: 6 },
    { i: "b", x: 6, y: 0, w: 3, h: 6 },
    { i: "c", x: 9, y: 0, w: 3, h: 12 },
    { i: "d", x: 0, y: 2, w: 3, h: 6 },
    { i: "e", x: 3, y: 2, w: 6, h: 6 },
    { i: "f", x: 0, y: 4, w: 6, h: 6 },
    { i: "g", x: 6, y: 4, w: 3, h: 6 },
  ];

  const layout2 = [
    { i: "a", x: 0, y: 0, w: 5, h: 6 },
    { i: "b", x: 5, y: 0, w: 2.5, h: 6 },
    { i: "c", x: 7.5, y: 0, w: 2.5, h: 12 },
    { i: "d", x: 0, y: 2, w: 2.5, h: 6 },
    { i: "e", x: 2.5, y: 2, w: 5, h: 6 },
    { i: "f", x: 0, y: 4, w: 5, h: 6 },
    { i: "g", x: 5, y: 4, w: 2.5, h: 6 },
    { i: "h", x: 7.5, y: 4, w: 2.5, h: 6 },
  ];

  const layout3 = [
    { i: "a", x: 0, y: 0, w: 4, h: 12 },
    { i: "b", x: 4, y: 0, w: 2, h: 6 },
    { i: "c", x: 0, y: 4, w: 2, h: 12 },
    { i: "d", x: 4, y: 2, w: 2, h: 6 },
    { i: "e", x: 2, y: 4, w: 4, h: 6 },
    { i: "f", x: 2, y: 6, w: 4, h: 6 },
    { i: "g", x: 0, y: 8, w: 2, h: 6 },
    { i: "h", x: 2, y: 8, w: 2, h: 6 },
  ];

  const layout4 = [
    { i: "a", x: 0, y: 0, w: 4, h: 8 },
    { i: "b", x: 2, y: 4, w: 2, h: 4 },
    { i: "c", x: 0, y: 4, w: 2, h: 8 },
    { i: "d", x: 0, y: 8, w: 4, h: 8 },
    { i: "e", x: 0, y: 2, w: 4, h: 4 },
    { i: "f", x: 0, y: 10, w: 4, h: 4 },
    { i: "g", x: 0, y: 12, w: 2, h: 4 },
    { i: "h", x: 2, y: 6, w: 2, h: 4 },
  ];

  const layouts = {
    lg: layout,
    md: layout2,
    sm: layout3,
    xs: layout4,
    // xss: layout5,
  };

  // if (loading) {
  //   return (
  //     <StyledLoaderWrapper>
  //       <Loader />
  //     </StyledLoaderWrapper>
  //   );
  // }

  return (
    <main>
      <StyledGridWrapper>
        <PaddingVertical>
          <StyledTitle>Glimpse Board</StyledTitle>
          <ResponsiveGridLayout
            rowHeight={33.3}
            containerPadding={[0, 0]}
            layouts={layouts}
            isDraggable={false}
            draggableHandle=".grid-item__title"
            isResizable={false}
            margin={[10, 10]}
            useCSSTransforms={true}
            cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 4 }}
          >
            <div className="grid-item__title" key="a">
              <HorizonalCard
                title="Hello There!"
                desc={
                  <>
                    🇺🇸 based <span style={{ fontWeight: 500 }}>CS grad</span> &{" "}
                    <span style={{ fontWeight: 500 }}>Full-stack</span>{" "}
                    developer. I build clean, scalable solutions and am{" "}
                    <StyledHighlighter>
                      seeking full-time roles
                    </StyledHighlighter>{" "}
                  </>
                }
                btnName="Want to know me more?"
                btnIcon={ArrowUpRight}
                btnLink="/about"
              />
            </div>

            <div className="grid-item__title" key="b">
              <SquareCard
                darkImg={getImageObj("xdark")}
                lightImg={getImageObj("xlight")}
                cardLink="https://x.com/harshptl14"
                blank={true}
              />
            </div>

            <div className="grid-item__title" key="c">
              <VarticalCard
                darkImg={getImageObj("toolpooldark")}
                lightImg={getImageObj("toolpoollight")}
                cardLink="https://toolpool.app/"
                buttonLink="/projects"
              />
            </div>
            <div className="grid-item__title" key="d">
              {/* <SpotifyCard
                title={result === false ? "" : result?.title}
                desc={result === false ? "Currently Offline" : result?.artist}
                darkImg={getImageObj("spotifydarksketch")}
                lightImg={getImageObj("spotifylightsketch")}
                link={result === false ? "" : result?.songUrl}
              /> */}
               <SquareCard
                darkImg={getImageObj("lidark")}
                lightImg={getImageObj("lilight")}
                cardLink="https://www.linkedin.com/in/harshptl14/"
                blank={true}
              />
            </div>
            <div className="grid-item__title" key="e">
              <HorizonalCard
                title="Have a gig?"
                desc="Let's work together! Get in touch with me and let's make something awesome!"
                btnName="Contact me"
                btnIcon={ArrowUpRight}
                footertext="howdy.harsh@gmail.com"
                btnLink="/contact"
              />
            </div>
            <div className="grid-item__title" key="f">
              <HorizonalCard
                title="How I made this portfolio"
                desc="Complete process of how I made this portfolio."
                btnName="See all blogs"
                btnIcon={ArrowUpRight}
                // footertext="howdy.harsh@gmail.com"
                btnLink="/blogs"
                cardLink="/blogs/how-i-made-this-portfolio"
              />
            </div>

            <div className="grid-item__title" key="g">
              <SquareCard
                darkImg={getImageObj("sketchdark")}
                lightImg={getImageObj("sketchlight")}
                cardLink="/misc/sketches"
                blank={false}
              />
            </div>

            <div className="grid-item__title" key="h">
              <SquareCard
                darkImg={getImageObj("photodarksketch")}
                lightImg={getImageObj("photolightsketch")}
                cardLink="/misc/clicks"
                blank={false}
              />
            </div>
          </ResponsiveGridLayout>
        </PaddingVertical>
      </StyledGridWrapper>
    </main>
  );
};

export default IndexPage;

export const pageQuery = graphql`
  query GetHomescreenImages {
    allFile(filter: { relativeDirectory: { eq: "homescreenImages" } }) {
      nodes {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED, width: 200)
        }
        name
      }
    }
  }
`;

export const Head: HeadFC = () => <SEO image={posterIndex}></SEO>;
